import { render, staticRenderFns } from "./edit-nivel-acceso-mesa.vue?vue&type=template&id=2f65b12b&"
import script from "./edit-nivel-acceso-mesa.vue?vue&type=script&lang=js&"
export * from "./edit-nivel-acceso-mesa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports